import { defineComponent as _defineComponent } from 'vue';
import { BContainer } from "bootstrap-vue";
import LoadingSpan from "@/components/LoadingSpan.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CreateInstance',
    props: {
        loading: { type: Boolean },
        loadingMessage: null
    },
    setup(__props) {
        return { __sfc: true, BContainer, LoadingSpan };
    }
});
